// extracted by mini-css-extract-plugin
export var numpadContainer = "_m0-1";
export var phoneButton = "_m0-0";